import { createColumnHelper } from '@tanstack/react-table';
import { groupBy } from 'lodash';
import { useMemo } from 'react';

import {
    excludeTradesCol,
    expanderCol,
    moneyCol,
    numberCol,
    textCol,
} from '../../../widgets/Table/columnHelpers/colDef';
import { CommonTradePlanEntry, getTradeAggregates, TradeTableProps } from './tradeExecutionUtils';
import { TradesTable } from './TradesTable';

interface TradePlanEntry extends CommonTradePlanEntry {
    allocationType: string;
}

const columnHelper = createColumnHelper<TradePlanEntry>();
export const TradesByAllocationType = ({
    secondaryGrouping,
    filteredTrades,
    excludeTrades,
    viewAsset,
    viewPortfolio,
    viewTrade,
    viewAdvanced,
}: TradeTableProps) => {
    const data: TradePlanEntry[] = useMemo(() => {
        if (!filteredTrades) {
            return [];
        }

        const grouped = groupBy(filteredTrades, (trade) => trade.allocationType);
        return Object.entries(grouped).map(([allocationType, trades]) => {
            return {
                allocationType,
                trades,
                ...getTradeAggregates(trades),
            };
        });
    }, [filteredTrades]);

    const columns = [
        columnHelper.display(expanderCol()),
        columnHelper.accessor('allocationType', textCol({ id: 'allocationType' })),
        columnHelper.accessor('tradesCount', numberCol({ id: 'tradesCount', format: { fractionDigits: 0 } })),
        columnHelper.accessor('totalQuantity', numberCol({ id: 'totalQuantity', format: { fractionDigits: 0 } })),
        columnHelper.accessor('totalValue', moneyCol({ id: 'totalValue' })),
        columnHelper.display(excludeTradesCol(excludeTrades)),
    ];

    return (
        <TradesTable
            data={data}
            secondaryGrouping={secondaryGrouping}
            columns={columns}
            excludeTrades={excludeTrades}
            viewAsset={viewAsset}
            viewPortfolio={viewPortfolio}
            viewTrade={viewTrade}
            viewAdvanced={viewAdvanced}
        />
    );
};
